/**
 * Read-only image utilities for job card photo viewing in pos-portal.
 * Adapted from workshop-app/src/utils/imageUtils.js — write operations removed.
 */

/**
 * Normalize an API image response into the shape expected by UI components.
 * 
 * @param {Object} apiImage - Image from GET /tenants/job-cards/:id response
 *   { id, url, thumbnailUrl, stage, caption, createdAt }
 * @returns {Object} - Normalized image for UI components
 */
export function normalizeApiImage(apiImage) {
    return {
        id: apiImage.id,
        url: apiImage.url || null,
        thumbnailUrl: apiImage.thumbnailUrl || apiImage.url || null,
        stage: apiImage.stage,
        caption: apiImage.caption,
        uploadedAt: apiImage.createdAt,
    };
}

/**
 * Request a fresh signed URL for a specific job card image.
 * Used when opening full-size preview after the initial signed URL may have expired.
 * 
 * @param {Function} tenantApi - The configured API client function
 * @param {string} jobCardId - The job card ID
 * @param {string} imageId - The JobCardImage ID
 * @returns {Promise<{url: string, thumbnailUrl: string|null}>}
 */
export async function getImageUrl(tenantApi, jobCardId, imageId) {
    const response = await tenantApi(`/tenants/job-cards/${jobCardId}/images/${imageId}/url`);
    return response.data;
}
